import LocalPoliceIcon from '@mui/icons-material/LocalPolice';
import ShieldIcon from '@mui/icons-material/Shield';
import { Tooltip } from '@mui/material';
import { feature } from 'src/models/workspaceUserFeatures.interface';

type Props = {
  features?: string[];
  color?:
    | 'inherit'
    | 'action'
    | 'disabled'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
  fontSize?: 'inherit' | 'large' | 'medium' | 'small';
};

export const SupportUserIcon = ({
  features = [],
  color = 'warning',
  fontSize = 'large'
}: Props) => {
  if (features.includes(feature.support.supportTech)) {
    return (
      <Tooltip title="This feature is only available to Support Tech users">
        <LocalPoliceIcon color={color} fontSize={fontSize} />
      </Tooltip>
    );
  }

  if (features.includes(feature.support.supportAdmin)) {
    return (
      <Tooltip title="This feature is only available to Support Admin users">
        <ShieldIcon color={color} fontSize={fontSize} />
      </Tooltip>
    );
  }

  return null;
};
